export enum TimelineWsEvents {
  GetTimeline = 'get_timeline'
}
